import { isValidPhone } from '@brazilian-utils/brazilian-utils';

export const phoneMessage = 'Telefone inválido';

export { isValidPhone };
